import React, { useState } from "react";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";

const SettingsTab = ({ t, handleLogout }) => {
  const [sending, setSending] = useState(false);
  const [msg, setMsg] = useState(null); // { type: 'success' | 'error', text: string }

  const handlePasswordReset = async () => {
    setMsg(null);

    const auth = getAuth();
    const email =
      auth.currentUser?.email ||
      JSON.parse(localStorage.getItem("user") || "{}")?.email ||
      "";

    if (!email) {
      setMsg({ type: "error", text: t("account.no_email_for_reset") });
      return;
    }

    try {
      setSending(true);
      // Optional: set where users land after clicking the email link
      const actionCodeSettings = {
        url: `${window.location.origin}/login`,
        handleCodeInApp: false,
      };

      await sendPasswordResetEmail(auth, email, actionCodeSettings);
      setMsg({
        type: "success",
        text: t("account.reset_link_sent", { email }),
      });
    } catch (err) {
      console.error("Password reset error:", err);
      let text = t("account.reset_link_error_generic");
      if (err.code === "auth/invalid-email")
        text = t("account.reset_link_error_invalid");
      if (err.code === "auth/user-not-found")
        text = t("account.reset_link_error_not_found");
      setMsg({ type: "error", text });
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="settings-section">
      <h2>{t("account.account_settings")}</h2>

      {/* ✅ Toggle for Dark Mode <div className="settings-item"> <span>{t("account.dark_mode")}</span> <label className="toggle-switch"> <input type="checkbox" /> <span className="slider"></span> </label> </div> */}

      {/* ✅ Notification Preferences */}
      <div className="settings-item">
        <span>{t("account.notifications")}</span>
        <label className="toggle-switch">
          <input type="checkbox" />
          <span className="slider"></span>
        </label>
      </div>

      {/* ✅ Change Password -> sends reset email */}
      <button className="update-btn" onClick={handlePasswordReset} disabled={sending}>
        {sending ? t("account.sending_reset") : t("account.change_password")}
      </button>

      {/* ✅ Feedback message */}
      {msg && (
        <p
          style={{
            marginTop: 8,
            color: msg.type === "success" ? "#00C853" : "#E63946",
            fontSize: 14,
          }}
        >
          {msg.text}
        </p>
      )}

      {/* ✅ Logout */}
      <button className="logout-btn" onClick={handleLogout}>
        {t("account.logout")}
      </button>
    </div>
  );
};

export default SettingsTab;
